/**
 * Constants index file
 * Exports all constants from the constants directory
 */

import { config, bookWorksheetConfig } from './config';

// Export all constants
export {
  config,
  bookWorksheetConfig
};

// Export literary group types
export const literaryGroupTypes = [
  { key: 'collection', text: 'Collection', value: 'collection' },
  { key: 'cycle', text: 'Cycle', value: 'cycle' },
  { key: 'series', text: 'Series', value: 'series' },
  { key: 'standalone', text: 'Standalone', value: 'standalone' },
  { key: 'anthology', text: 'Anthology', value: 'anthology' }
];

// Export character gender options
export const genderOptions = [
  { key: 'male', text: 'Male', value: 'male' },
  { key: 'female', text: 'Female', value: 'female' },
  { key: 'non-binary', text: 'Non-Binary', value: 'non-binary' },
  { key: 'other', text: 'Other', value: 'other' }
];

// Export age range options
const ageRangeOptions = [
  { key: 'child', text: 'Child (0-12)', value: 'child' },
  { key: 'teen', text: 'Teen (13-19)', value: 'teen' },
  { key: 'young-adult', text: 'Young Adult (20-29)', value: 'young-adult' },
  { key: 'adult', text: 'Adult (30-59)', value: 'adult' },
  { key: 'senior', text: 'Senior (60+)', value: 'senior' },
  { key: 'dragon', text: 'Dragon', value: 'dragon' },
  { key: 'computer', text: 'Computer', value: 'computer' }
];

// Export default values
export const defaultValues = bookWorksheetConfig.defaults;

// Export validation values
export const validationRules = bookWorksheetConfig.validation;

// Export UI configuration
export const uiConfig = bookWorksheetConfig.ui;

// Export default
export default {
  config,
  bookWorksheetConfig,
  literaryGroupTypes,
  genderOptions,
  ageRangeOptions,
  defaultValues,
  validationRules,
  uiConfig
};
